<template>
    <svg :width="width" :height="height" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.7321 14.0186V7.03563C17.7321 6.02756 17.3707 5.07654 16.7144 4.35727L13.8288 1.14799C13.8274 1.14646 13.826 1.14488 13.8246 1.14335C13.1602 0.416743 12.2358 0 11.2883 0H2.13354C0.957106 0 0 1.02934 0 2.29456V22.1298C0 23.395 0.957106 24.4243 2.13354 24.4243H13.1252C14.1387 25.4662 15.5115 26.107 17.0209 26.107C20.1581 26.107 22.7103 23.385 22.7103 20.0392C22.7103 16.9502 20.5348 14.3931 17.7321 14.0186ZM1.42236 22.1298V2.29456C1.42236 1.87282 1.74139 1.52971 2.13354 1.52971H11.2883C11.856 1.52971 12.41 1.7791 12.8086 2.21389L15.6937 5.42266C15.6951 5.42419 15.6964 5.42572 15.6978 5.4272C16.0924 5.85893 16.3097 6.43012 16.3097 7.03568V14.0194C13.5332 14.3966 11.3789 16.9524 11.3789 20.0392C11.3789 21.0709 11.6198 22.0431 12.0439 22.8947H2.13354C1.74139 22.8946 1.42236 22.5515 1.42236 22.1298ZM17.0209 24.5773C14.6942 24.5773 12.8012 22.5415 12.8012 20.0392C12.8012 17.5368 14.6942 15.501 17.0209 15.501C19.3738 15.501 21.288 17.5368 21.288 20.0392C21.288 22.5415 19.3738 24.5773 17.0209 24.5773Z"
        />
        <path
            d="M18.6615 18.2274C18.3598 17.9571 17.9113 18.0009 17.6598 18.3253L16.4595 19.8745L16.1872 19.2888C16.0116 18.911 15.5844 18.7577 15.2331 18.9468C14.8817 19.1356 14.7394 19.5951 14.915 19.9729L15.6736 21.6046C15.7809 21.8355 15.9893 21.9925 16.2277 22.0223C16.2552 22.0256 16.2825 22.0274 16.3098 22.0274C16.5194 22.0274 16.7201 21.9276 16.8561 21.7522L18.7525 19.3047C19.004 18.9801 18.9632 18.4978 18.6615 18.2274Z"
        />
        <path
            d="M7.53838 15.5521H3.74542C3.35266 15.5521 3.03424 15.8946 3.03424 16.317C3.03424 16.7394 3.35266 17.0818 3.74542 17.0818H7.53838C7.93114 17.0818 8.24956 16.7394 8.24956 16.317C8.24956 15.8946 7.93114 15.5521 7.53838 15.5521Z"
        />
        <path
            d="M7.53838 11.4724H3.74542C3.35266 11.4724 3.03424 11.8148 3.03424 12.2372C3.03424 12.6596 3.35266 13.0021 3.74542 13.0021H7.53838C7.93114 13.0021 8.24956 12.6596 8.24956 12.2372C8.24956 11.8148 7.93114 11.4724 7.53838 11.4724Z"
        />
        <path
            d="M7.53838 7.39325H3.74542C3.35266 7.39325 3.03424 7.7357 3.03424 8.1581C3.03424 8.58051 3.35266 8.92296 3.74542 8.92296H7.53838C7.93114 8.92296 8.24956 8.58051 8.24956 8.1581C8.24956 7.7357 7.93114 7.39325 7.53838 7.39325Z"
        />
        <path
            d="M11.3316 8.92296H12.0902C12.4829 8.92296 12.8014 8.58051 12.8014 8.1581C12.8014 7.7357 12.4829 7.39325 12.0902 7.39325H11.3316C10.9388 7.39325 10.6204 7.7357 10.6204 8.1581C10.6204 8.58051 10.9388 8.92296 11.3316 8.92296Z"
        />
        <path
            d="M12.8014 12.2372C12.8014 11.8148 12.4829 11.4724 12.0902 11.4724H11.3316C10.9388 11.4724 10.6204 11.8148 10.6204 12.2372C10.6204 12.6596 10.9388 13.0021 11.3316 13.0021H12.0902C12.4829 13.0021 12.8014 12.6596 12.8014 12.2372Z"
        />
    </svg>
</template>
<script>
export default {
    name: 'IconEvaluation',
    props: {
        width: {
            type: Number,
            default: 23,
        },
        height: {
            type: Number,
            default: 20,
        },
    },
}
</script>
